import React, {useState, Fragment, useCallback, useEffect, useReducer} from 'react';
import { useForm } from 'react-hook-form';
import { Card, CardBody, CardHeader, Form, FormGroup, Input,Row, Col, Label  } from 'reactstrap';
import { Breadcrumbs, Btn, H4 } from '../../../../AbstractElements';
import DataTable from 'react-data-table-component';
import { treatmentprocedure, proceduretableColumns } from '../../../../Data/TreatmentSettings';
import CommonModal from '../../../Common/Component/CommonModal';
import RequiredField from '../../../../Constant';
import { toast } from 'react-toastify';
import SweetAlert from 'sweetalert2';
import { CreateTreatmentProcedure, DeleteTreatmentProcedure, TreatmentPlanList, TreatmentProcedureList, UpdateTreatmentProcedure } from '../../../../apiController';

import { roles_permissions } from '../../../../Layout/Sidebar/Menu';

const initialState = {
  treatmentplan:'',
  treatmentprocedure:'',
  id:''
};

const reducer = (state, action) => {
  switch (action.type) {
    
    case 'SET_TREATMENTPLAN':
      return { ...state, treatmentplan: action.payload };
    case 'SET_TREATMENTPROCEDURE':
      return { ...state, treatmentprocedure: action.payload };
    case 'SET_ID':
      return { ...state, id: action.payload };
    case 'RESET_FORM':
      return initialState;
    default:
      return state;
  }
};
const TreatmentProcedure = () =>{

  const [Large, setLarge] = useState(false);
  const [state, dispatch] = useReducer(reducer, initialState);
  const LargeModaltoggle = () => {setLarge(!Large); dispatch({type:'RESET_FORM'})};

  const permission = roles_permissions.find(module => module.module_name === 'Treatment Procedure')

  const [formdata, setFormdata] = useState({});
  const [treatmentPlan, setTreatmentPlan] = useState([]);
  const [treatmentProcedure, setTreatmentProcedure] = useState([]);


  const {
    register,
    handleSubmit,
    formState: { errors },
    reset
  } = useForm();

  const [searchKeyword, setSearchKeyword] = useState('');
  const handleSearchKeyword = (keyword) => {
      setSearchKeyword(keyword);
      // searchMember(keyword);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    dispatch({ type: `SET_${name.toUpperCase()}`, payload: value });
    
  };

  const handleEdit = (row) => {
    console.log(row)
    // setFormdata({ id: row.id, dname: row.dname , diagnosis: row.name});
    setLarge(!Large);
    
  dispatch({ type: 'SET_TREATMENTPLAN', payload: row.treatment_plan_id });
  dispatch({ type: 'SET_TREATMENTPROCEDURE', payload: row.treatment_procedure });
  dispatch({ type: 'SET_ID', payload: row.id });
  };

  const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelet, setToggleDelet] = useState(false);
    // const [data, setData] = useState(treatmentprocedure);

    const proceduretableColumns = [
      {
          name: '#',
          selector: row => row['ind'],
          sortable: true,
          center: false,
      },
      {
          name: 'Treatment Plan',
          selector: row => row['treatmentplan'],
          sortable: true,
          center: true,
      },
      {
          name: 'Treatment Procedure',
          selector: row => row['treatmentprocedure'],
          sortable: true,
          center: true,
      },
      // {
      //     name: 'Action',
      //     selector: row => <row.action LargeModaltoggle={row.LargeModaltoggle} />,
      //     sortable: false,
      //     center: true,
      // },
  ];

  if(permission?.edit_access){
    proceduretableColumns.push(
      {
        name: 'Action',
        selector: row => <row.action LargeModaltoggle={row.LargeModaltoggle} />,
        sortable: false,
        center: true,
    },
    )
  }
  
 const treatmentprocedure = treatmentProcedure.map(((row, ind)=>(
      {
        ind: ind+1,
        id: row.id,
          treatmentplan:row.treatment_plan_name,
          treatmentprocedure:row.treatment_procedure,
          action: 
          ({ LargeModaltoggle }) => (
              <span>
                  <Btn
                      attrBtn={{
                          style: { width: 60, fontSize: 14, padding: 4 },
                          color: 'success',
                          className: 'btn btn-xs',
                          type: 'button',
                          onClick: () => handleEdit(row)
                      }}
                  >
                      Edit
                  </Btn>
              </span>
          )
      })
    )
  )


  const handleSaveForm = async () => {  

    const formattedData = {
      treatment_plan_id: state.treatmentplan,
      treatment_procedure: state.treatmentprocedure,
      id: state.id
  };
  console.log(state)
  console.log(formattedData)

  try {
    if (state.id) {
        const response = await UpdateTreatmentProcedure(formattedData);
        if (response.status === true) {
            toast.success('Updated Successfully!', { position: toast.POSITION.TOP_CENTER });
            
            

        }
    } else {
        const response = await CreateTreatmentProcedure(formattedData);
        if (response.status === true) {
            toast.success('Created Successfully!', { position: toast.POSITION.TOP_CENTER });
            
        }
    }
    fetchTreatmentProcedure()
    LargeModaltoggle();
} catch (error) {
    toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
}
    dispatch({type:'RESET_FORM'})
  };

    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    const handleDelete = async () => {
      const result = await SweetAlert.fire({
        title: 'Are you sure you want to delete?',
        cancelButtonText: 'No!',
        confirmButtonText: 'Yes!',
        reverseButtons: true,
        showCancelButton: true,
      });
    
      if (result.isConfirmed) {
        try {
          const selectedIds = selectedRows.map(row => row.id); 
          await Promise.all(selectedIds.map(id => DeleteTreatmentProcedure(id)));
          setSelectedRows([]);
          toast.success('Deleted Successfully!', { position: toast.POSITION.TOP_CENTER });
          fetchTreatmentProcedure()
        } catch (error) {
          toast.error('An error occurred!', { position: toast.POSITION.TOP_CENTER });
        }
      }
    };

    const fetchTreatmentPlan = async () => {
      const response = await TreatmentPlanList();
      if (response.status === true) {
        setTreatmentPlan(response.data);
      }
    };
    const fetchTreatmentProcedure = async () => {
      const response = await TreatmentProcedureList();
      if (response.status === true) {
        setTreatmentProcedure(response.data);
      }
    };

    useEffect(()=>{
      fetchTreatmentPlan()
      fetchTreatmentProcedure()
    },[])
  return (
    <Card>
      <Breadcrumbs mainTitle='Treatment Procedure' parent='Dashboard' title='treatmentprocedure' />
      <CardHeader className='card-no-border'>
        <div className='header-top'>
          <Fragment>
  <div className="search">
    <Form className="theme-form">
      <FormGroup className="form-group">
        <div className="input-group">
          <Input
            className="form-control"
            type="text"
            placeholder="search"
            defaultValue={searchKeyword}
            onChange={(e) => handleSearchKeyword(e.target.value)}
          />
          <div className="input-group-append">
            <span className="input-group-text">
              <i className="fa fa-search"></i>
            </span>
          </div>
        </div>
      </FormGroup>
    </Form>
  </div>
</Fragment>
          <div className='card-header-right-icon'>
            <div className='card-header-right-icon'>
            {permission?.create_access && <Btn attrBtn={{ color: 'light-primary', className: 'btn badge-light-primary' , onClick: LargeModaltoggle}}>+ Add Procedure</Btn> }
            <CommonModal isOpen={Large} title={"Treatment Procedure"} toggler={LargeModaltoggle} size="lg" onSave={handleSaveForm} formdata={formdata}>
              <Row>
              <Col sm="12">
               
                          <FormGroup className="mb-3">
                                    <Label htmlFor="exampleFormControlSelect9">{'Treatment Plan'} <RequiredField/></Label>
                                    <Input type="select" name="treatmentplan" className="form-control digits" id="treatmentplan"  value={state.treatmentplan} onChange={handleChange} >
                                    <option  value=''>Select Treatment Plan</option>
                                 
                                      {treatmentPlan.map((type)=> <option key={type.id} value={type.id}>{type.treatment_plan}</option>
                                      )}
                                     </Input>
                                   
                                    <span className="text-danger">{errors.diagnosis && "Treatment Plan is required"}</span>
                            </FormGroup>
                                <FormGroup className="mb-3">
                                      <Label htmlFor="fname">{"Treatment Procedure"} <RequiredField/></Label>
                                      <input className={`form-control ${errors.treatmentprocedure && "is-invalid"}`} id="treatmentprocedure" type="text" name="treatmentprocedure" value={state.treatmentprocedure} onChange={handleChange}/>
                                      <span className="text-danger">{errors.treatmentprocedure && " is required"}</span>
                                </FormGroup>
            </Col>
            </Row>
            </CommonModal>
          </div>
          </div>
        </div>
      </CardHeader>
      <CardBody className='pt-0 campaign-table'>
        <div className='recent-table table-responsive currency-table'>
        <Fragment>
        {(selectedRows.length !== 0) &&
                <div className={`d-flex align-items-center justify-content-between bg-light-info p-2`}>
                    <H4 attrH4={{ className: 'text-muted m-0' }}>Delet Selected Data..!</H4>
                    <Btn attrBtn={{ color: 'danger', onClick: () => handleDelete() }}>Delete</Btn>
                </div>
            }
        <DataTable
                data={treatmentprocedure}
                columns={proceduretableColumns}
                striped={true}
                center={true}
                pagination 
                selectableRows = {permission?.delete_access}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleDelet}
            />
            </Fragment>
        </div>
      </CardBody>
    </Card>
  );
}

export default TreatmentProcedure